import React, { Component } from "react";
import Waypoint from "react-waypoint";
import _ from "lodash";
import styled from "styled-components";

const ChildrenStyled = styled.div`
  width: 100%;
  height: 100%;
  transition: all 1s;
  opacity: ${props => (props.isAppear ? 1 : 0)};
`;

export default class MyWaypoint extends Component {
  constructor(props) {
    super(props);
    this.state = { isAppear: false, anime: props.anime };
  }
  static defaultProps = {
    reappear: true,
    topOffset: 60
  };
  onEnter = () => {
    if (this.state.isAppear) return;
    this.setState({ isAppear: true });
  };
  onLeave = () => {
    if (!this.state.isAppear) return;
    if (!this.props.reappear) return;
    this.setState({ isAppear: false });
  };
  doAnime = anime => {
    _.map(anime, value => {
      value();
    });
  };
  render() {
    const { topOffset } = this.props;
    const { isAppear, anime } = this.state;
    if (isAppear) {
      if (anime) {
        setTimeout(() => {
          this.doAnime(anime);
        }, 1);
      }
    }
    return (
      <Waypoint topOffset={topOffset} {...this.props} onEnter={this.onEnter} onLeave={this.onLeave}>
        <ChildrenStyled isAppear={isAppear}>
          {isAppear ? this.props.children : <span>{this.props.children}</span>}
        </ChildrenStyled>
      </Waypoint>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MyWaypoint.js